import BorderedIcon from "@/components/BorderedIcon";
import CustomSplitText from "@/mono/components/CustomSplitText";
import styled from "styled-components";
import ColumnRow, { columnRowTypeNames } from "../../contentSections/ColumnRow";
import WhatWeDoServiceHeader from "../WhatWeDoHeader";

export default function WhatWeDoServiceIdentity() {
  return (
    <Wrapper>
      <WhatWeDoServiceHeader
        service="Identity"
        className="what-we-do__identities"
      >
        <CustomSplitText tag="p">
          Een sterke merkidentiteit is het fundament voor zichtbaarheid,
          vertrouwen en groei. Bij Nine draait branding om een uniek, consistent
          en authentiek verhaal dat klanten aantrekt én behoudt. Een krachtige
          identiteit zorgt voor meer klanten, loyaliteit, herkenning en een
          sterke marktpositie. Met de juiste uitstraling wordt jouw merk
          onvergetelijk.
        </CustomSplitText>

        <BorderedIcon
          text={"More about <strong>identities</strong>"}
          className="what-we-do__identities-arrow"
          href="/service/identity"
        />
      </WhatWeDoServiceHeader>

      <ColumnRow
        data={{
          columns: [
            {
              __typename: columnRowTypeNames.image,
              image: {
                url: "/images/what-we-do/identity1.jpeg",
              },
              width: 50,
            },
            {
              __typename: columnRowTypeNames.image,
              image: {
                url: "/images/what-we-do/identity2.webp",
              },
              width: 50,
            },
          ],
        }}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .what-we-do__identities {
  }
  .what-we-do__identities-arrow {
    margin-top: 100rem;
  }
  margin-bottom: 150rem;
`;
